import { render } from "./SelfAssessmentV2HeroCard.vue?vue&type=template&id=33765c37&scoped=true"
import script from "./SelfAssessmentV2HeroCard.vue?vue&type=script&lang=js"
export * from "./SelfAssessmentV2HeroCard.vue?vue&type=script&lang=js"

import "./SelfAssessmentV2HeroCard.vue?vue&type=style&index=0&id=33765c37&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33765c37"]])

export default __exports__